import { csrftoken } from "../shared/utils.js";
import { NetworkError, HTTPError } from "../shared/errors.js";

/*
  Returns a promise containing the json data for a response,
  or an error payload containing the error type, response, and any json errors (param).
*/
function getJsonOrThrow(response) {
  let json = response.json();
  if (response.ok) {
    return json;
  } else {
    return json.then((data) => Promise.reject(new HTTPError(response, data)));
  }
}

let fetchError = (error) => Promise.reject(new NetworkError(error));

/*
 * DELETE a single business update.
 *
 * @param {Number} id - the primary key of the update to delete.
 */
export function deletePost(id) {
  return fetch(`/blog/posts/${id}/`, {
    method: "DELETE",
    headers: {
      "X-CSRFToken": csrftoken,
    },
  })
    .catch(fetchError)
    .then((response) => {
      // no json to get so just check response is OK
      if (response.ok) {
        return Promise.resolve();
      } else {
        return Promise.reject(new HTTPError(response));
      }
    });
}

/*
 * GET a list of business updates from the backend server.
 *
 * @param {String} businessCode - code which identifies the relevant business profile
 * @param {Boolean} onlyPublic - whether or not to filter updates on the `public` flag.
 *                               Default is to return *all* (i.e. public and private) updates.
 */
export function listPosts(businessCode, onlyPublic) {
  let endpoint = `/blog/posts/?business_profile__business_code=${businessCode}`;
  endpoint += onlyPublic ? `&public=${onlyPublic}` : "";

  return fetch(endpoint).catch(fetchError).then(getJsonOrThrow);
}
